export const siteToPersona = {
  southwest: "leisure",
  corporate: "corporate",
};
